import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CheckCircle2, Download, Loader2, XCircle, FileText } from 'lucide-react';
import { RUNTIME_BACKEND_URL } from '../lib/backendUrl';
import { tl } from '../lib/whatsapp';

const API = `${RUNTIME_BACKEND_URL}/api/hesap/public/teklif`;
const STATUS = { onaylandi: ['Onaylandı', 'bg-emerald-100 text-emerald-700'], reddedildi: ['Reddedildi', 'bg-red-100 text-red-700'] };

export default function PublicTeklifPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetch(`${API}/${token}`).then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.detail); setData(d); })
      .catch(e => setError(e.message || 'Teklif bulunamadı'));
  }, [token]);

  const respond = async (action) => {
    if (!window.confirm(action === 'onaylandi' ? 'Teklifi onaylıyor musunuz?' : 'Teklifi reddetmek istediğinize emin misiniz?')) return;
    setBusy(true);
    const r = await fetch(`${API}/${token}/respond`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action }) });
    const d = await r.json();
    setBusy(false);
    if (r.ok) setData(x => ({ ...x, teklif: { ...x.teklif, status: d.status } }));
    else window.alert(d.detail);
  };

  if (error) return <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="public-teklif-error">{error}</div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  const { teklif: t, firma } = data;
  const st = STATUS[t.status];

  return (
    <div className="min-h-screen bg-slate-100 py-8 px-4" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="public-teklif-page">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="bg-slate-900 text-white p-6 sm:p-8 flex flex-wrap items-start justify-between gap-4">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-emerald-400 font-bold">Fiyat Teklifi</p>
            <h1 className="text-2xl sm:text-3xl font-bold mt-1">{firma.name || 'Teklif'}</h1>
            <p className="text-sm text-slate-400 mt-1">{[firma.phone, firma.email, firma.address].filter(Boolean).join(' · ')}</p>
          </div>
          <div className="text-right">
            <p className="text-sm text-slate-400">No</p>
            <p className="font-mono font-bold">{t.teklif_no}</p>
            <p className="text-sm text-slate-400 mt-1">{t.date ? new Date(t.date).toLocaleDateString('tr-TR') : ''}</p>
          </div>
        </div>
        <div className="p-6 sm:p-8 space-y-6">
          <div className="flex flex-wrap justify-between gap-3">
            <div><p className="text-xs text-slate-500">Sayın</p><p className="font-semibold text-lg">{t.customer_name}</p></div>
            {st && <span className={`self-start px-3 py-1 rounded-full text-sm font-semibold ${st[1]}`} data-testid="public-teklif-status">{st[0]}</span>}
          </div>
          <div className="overflow-x-auto border rounded-xl">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-xs text-slate-500"><tr><th className="text-left p-3">Ürün / Hizmet</th><th className="p-3 text-right">Miktar</th><th className="p-3 text-right">Birim</th><th className="p-3 text-right">Tutar</th></tr></thead>
              <tbody>
                {(t.items || []).map((it, i) => (
                  <tr key={i} className="border-t"><td className="p-3">{it.name}</td><td className="p-3 text-right">{it.qty} {it.unit}</td><td className="p-3 text-right">{tl(it.price)}</td><td className="p-3 text-right font-medium">{tl(it.total)}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex justify-end"><div className="text-right"><p className="text-sm text-slate-500">Genel Toplam</p><p className="text-3xl font-bold text-emerald-600" data-testid="public-teklif-total">{tl(t.total)}</p></div></div>
          {t.notes && <p className="text-sm text-slate-600 bg-slate-50 rounded-xl p-4 whitespace-pre-line">{t.notes}</p>}
          <div className="flex flex-wrap gap-3 pt-2">
            <a href={`${API}/${token}/pdf`} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border font-medium hover:bg-slate-50" data-testid="public-teklif-pdf"><Download className="h-4 w-4" /> PDF İndir</a>
            {!st && (
              <>
                <button disabled={busy} onClick={() => respond('onaylandi')} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold" data-testid="public-teklif-approve"><CheckCircle2 className="h-4 w-4" /> Onaylıyorum</button>
                <button disabled={busy} onClick={() => respond('reddedildi')} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-red-200 text-red-600 hover:bg-red-50 font-medium" data-testid="public-teklif-reject"><XCircle className="h-4 w-4" /> Reddediyorum</button>
              </>
            )}
          </div>
        </div>
        <p className="text-center text-xs text-slate-400 pb-6 flex items-center justify-center gap-1"><FileText className="h-3 w-3" /> Bu teklif {firma.name} tarafından hazırlanmıştır.</p>
      </div>
    </div>
  );
}
